import { BORDER_RADIUS, primitiveColors, semanticColors } from '@/theme/tokens';

/** Settings controls and buttons share the language selector's rendered height. */
export const CONTROL_HEIGHT = { dialog: 37, page: 34 } as const;

export const SECTION_CARD_SX = {
  border: `1px solid ${semanticColors.borderLight}`,
  borderRadius: BORDER_RADIUS,
  p: 2.5,
  mb: 2,
  backgroundColor: primitiveColors.white,
} as const;

export const INPUT_SX = {
  '& .MuiInputBase-root': {
    borderRadius: BORDER_RADIUS,
    fontSize: '14px',
    '@media (pointer: coarse)': { fontSize: '16px' },
  },
} as const;

export const FIELD_LABEL_SX = {
  fontSize: '11px',
  fontWeight: 600,
  letterSpacing: '0.08em',
  color: semanticColors.textTertiary,
  textTransform: 'uppercase' as const,
  mb: 0.5,
} as const;
